import React from "react";
import styled from "styled-components";

const FooterContainer = styled.div`

  background: rgb(240, 240, 240);
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  position: fixed;
  bottom: 0;
  width: 100%;
  color: black;
  font-size: 14px;

  @media (max-width: 600px) {
    flex-direction: column;
    height: auto;
    padding: 10px;
    text-align: center;
  }
`;

const LinksContainer = styled.div`
  display: flex;
  gap: 15px;
  color: blue;
`;

const StyledCopyright = styled.div`
  margin-left: ${(props) => (props.$isloggedin ? "350px" : "0")};
  transition: margin-left 0.3s ease;
`;

const Footerbar = ({isLoggedIn}) => {
  return (

    <FooterContainer >
      <StyledCopyright $isloggedin={isLoggedIn}>Copyright : CV-IFIR Portal 2022</StyledCopyright>
      <LinksContainer >
        <a
          href="https://www.tatamotors.com/corporate-responsibility/governance/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
        <a
          href="https://www.tatamotors.com/legal-disclaimer/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Disclaimer
        </a>
      </LinksContainer>
    </FooterContainer>
  );
};

export default Footerbar;
